//引入封装好的 service
import service from "./service";
 
//声明一个基础接口变量
let baseURL = '/api/'
let sufixUrl = `?logId=${Date.now()}`
 
//设置请求头（如果请求头统一的话可以在axios文件设置，则无须从这里传过去）
const header = {
  Accept: 'application/json;charset=UTF-8',
}
 
let _service={
  getCode(data) {
    const url = 'hittec-basic/sendSms/getCode';
    return service.post(baseURL+url+sufixUrl, data, header);
  },
  validateSmsCode(data) {
    const url = 'hittec-basic/sendSms/validSmsCode';
    return service.post(baseURL+url+sufixUrl, data, header);
  },
  addCrmTmsClue(data) {
    const url = 'hittec-crm/crmTmsClue/addCrmTmsClue';
    return service.post(baseURL+url+sufixUrl, data, header);
  },
  addWebsiteData(data) {
    const url = 'hittec-crm/websiteData/addWebsiteData';
    return service.post(baseURL+url+sufixUrl, data, header);
  },
  loginPlatform(data) {
    const url = 'hittec-uaa/oauth/token';
    return service.post(baseURL+url+sufixUrl, data, {Accept: 'application/json;charset=UTF-8', 'Content-type': 'application/x-www-form-urlencoded;charset=UTF-8', Authorization: 'Basic cGxhdGZvcm06cGxhdGZvcm0='});
  },
  loginCustomer(data) {
    const url = 'hittec-uaa/oauth/token';
    return service.post(baseURL+url+sufixUrl, data, {Accept: 'application/json;charset=UTF-8', 'Content-type': 'application/x-www-form-urlencoded;charset=UTF-8', Authorization: 'Basic Y3VzdG9tZXI6Y3VzdG9tZXI='});
  },
  getUserByCode(data) {
    const url = 'hittec-crm/wechat/serviceAccount/getMpOAuth2AccessToken';
    return service.get(baseURL+url+sufixUrl, data, header);
  },
}
 
 
//导出
export default _service